<script lang="ts" module>
  import Icon from '@/ui/base/icon/Icon.svelte';
</script>

<footer class="flex items-end justify-end gap-3 p-4">
  <Icon icon="TCLLogo" size={14.5} class="flex-none" />
  <p class="ml-auto text-sm">Alle Rechte tcl.digital.</p>
  <a
    class="flex-none font-sans text-sm font-normal text-c-link"
    href="https://tcl.digital/impressum-datenschutz/"
    target="_blank">Datenschutzerklärung</a
  >
</footer>
